import { Skeleton } from '../../../Skeleton'

import {
  CALENDAR_GRID_AGENDA_SKELETON_DAYS_LENGTH,
  CALENDAR_GRID_AGENDA_SKELETON_ROWS_LENGTH,
} from './CalendarGridAgendaSkeleton.constants'

import * as styles from './CalendarGridAgendaSkeleton.module.css'

function CalendarGridAgendaSkeleton() {
  return (
    <div className={styles.CalendarGridAgendaSkeleton}>
      {Array.from({ length: CALENDAR_GRID_AGENDA_SKELETON_DAYS_LENGTH }).map(
        (_, dayIndex) => (
          <div className={styles.day} key={dayIndex}>
            <div className={styles.title}>
              <Skeleton className={styles.weekday} />
              <Skeleton className={styles.date} />
            </div>
            <div className={styles.rows}>
              {Array.from({
                length: CALENDAR_GRID_AGENDA_SKELETON_ROWS_LENGTH,
              }).map((_, rowIndex) => (
                <Skeleton className={styles.row} key={rowIndex} />
              ))}
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default CalendarGridAgendaSkeleton
